import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from 'src/app/components/_alert/alert.service';

@Component({
  selector: 'app-reporte-tesoreria-view',
  templateUrl: './reporte-tesoreria-view.component.html',
  styleUrls: ['./reporte-tesoreria-view.component.scss']
})
export class ReporteTesoreriaViewComponent implements OnInit {
  @Input() reporteFullContent!: any | null;
  @Input() rut!: string | null;
  public isResumida: boolean = false;

  public objKeys = Object.keys;
  public today: string = '';

  public camposEnteros: string[] = [
    'cantidad', 'vencidas',
    'noVencidas', 'noLiquidables',
    'montoLiquidado', 'deudaNeta',
    'reajuste', 'interes',
    'multa', 'total',
    'montoVoluntario', 'cantidadVoluntario',
    'montoNoVoluntario', 'cantidadNoVoluntario',
    'monto', 'montoRenta',
    'cantidadRenta', 'montoDevoluciones',
    'cantidadDevoluciones', 'montoBonificaciones',
    'cantidadBonificaciones', 'montoSubvenciones',
    'cantidadSubvenciones', 'montoAdministrativa',
    'cantidadAdministrativa', 'montoJudicial',
    'cantidadJudicial', 'montoQuiebra',
    'cantidadQuiebra', 'montoVigentes',
    'cantidadVigentes', 'montoCaducados',
    'cantidadCaducados', 'montoPagados',
    'cantidadPagados',
    'monotCuotaFija', 'montoCuotaContado', 'montoInicial'
  ];
  //public camposDecimales: string[] = [];
  public camposFechas: string[] = [
    'fechaVencimiento', 'fechaPago', 'fechaUltimoPago', 'fechaResolucion', 'fechaActivacion'
  ];
  //public camposPorc: string[] = []; // Porcentajes

  public headerContribuciones: any[] = [
    {key: 'cantidad', value: 'Cantidad'},
    {key: 'vencidas', value: 'Vencidas'},
    {key: 'noVencidas', value: 'No Vencidas'},
    {key: 'noLiquidables', value: 'No Liquidables'},
    {key: 'montoLiquidado', value: 'Monto Liquidado'},
  ]

  public headerFiscalesTotales: any[] = [
    {key: 'cantidad', value: 'Cantidad'},
    {key: 'vencidas', value: 'Vencidas'},
    {key: 'noVencidas', value: 'No Vencidas'},
    {key: 'noLiquidables', value: 'No Liquidables'},
    {key: 'montoLiquidado', value: 'Monto Liquidado'},
  ]

  public headerFiscales: any[] = [
    {key: 'tipoDeuda', value: 'Tipo Deuda'},
    {key: 'formulario', value: 'Formulario'},
    {key: 'tipo', value: 'Tipo'},
    {key: 'folio', value: 'Folio'},
    {key: 'fechaVencimiento', value: 'Fecha Vencimiento'},
    {key: 'deudaNeta', value: 'Deuda Neta'},
    {key: 'reajuste', value: 'Reajuste'},
    {key: 'interes', value: 'Interes'},
    {key: 'multa', value: 'Multa'},
    {key: 'total', value: 'Total'},
  ]

  public headerPagosTotales: any[] = [
    {key: 'montoVoluntario', value: 'Monto'},
    {key: 'cantidadVoluntario', value: 'Cantidad'},
    {key: 'montoNoVoluntario', value: 'Monto'},
    {key: 'cantidadNoVoluntario', value: 'Cantidad'},
  ]

  public headerPagosTotalesGroups = [
    { label: 'Voluntarios', colspan: 2 },
    { label: 'No Voluntarios', colspan: 2 }
  ]

  public headerPagosVoluntarios: any[] = [
    {key: 'formulario', value: 'Formulario'},
    {key: 'rol', value: 'Rol'},
    {key: 'folio', value: 'Folio'},
    {key: 'fechaVencimiento', value: 'Fecha Vencimiento'},
    {key: 'fechaPago', value: 'Fecha Pago'},
    {key: 'monto', value: 'Monto'},
  ]

  public headerPagosNoVoluntarios: any[] = [
    {key: 'formulario', value: 'Formulario'},
    {key: 'folio', value: 'Folio'},
    {key: 'fechaVencimiento', value: 'Fecha Vencimiento'},
    {key: 'fechaPago', value: 'Fecha Pago'},
    {key: 'monto', value: 'Monto'},
  ]

  public headerPagosRecTotales: any[] = [
    {key: 'montoRenta', value: 'Monto'},
    {key: 'cantidadRenta', value: 'Cantidad'},
    {key: 'montoDevoluciones', value: 'Monto'},
    {key: 'cantidadDevoluciones', value: 'Cantidad'},
    {key: 'montoBonificaciones', value: 'Monto'},
    {key: 'cantidadBonificaciones', value: 'Cantidad'},
    {key: 'montoSubvenciones', value: 'Monto'},
    {key: 'cantidadSubvenciones', value: 'Cantidad'},
  ]

  public headerPagosRecTotalesGroups = [
    { label: 'Renta', colspan: 2 },
    { label: 'Devoluciones', colspan: 2 },
    { label: 'Bonificaciones', colspan: 2 },
    { label: 'Subvenciones', colspan: 2 },
  ]

  public headerPagosRenta: any[] = [
    {key: 'formulario', value: 'Formulario'},
    {key: 'folio', value: 'Folio'},
    {key: 'fechaVencimiento', value: 'Fecha Vencimiento'},
    {key: 'fechaPago', value: 'Fecha Pago'},
    {key: 'monto', value: 'Monto'},
  ]

  public headerPagosDevoluciones: any[] = [
    {key: 'formulario', value: 'Formulario'},
    {key: 'folio', value: 'Folio'},
    {key: 'fechaVencimiento', value: 'Fecha Vencimiento'},
    {key: 'fechaPago', value: 'Fecha Pago'},
    {key: 'monto', value: 'Monto'},
  ]

  public headerPagosBonificaciones: any[] = [
    {key: 'formulario', value: 'Formulario'},
    {key: 'folio', value: 'Folio'},
    {key: 'fechaVencimiento', value: 'Fecha Vencimiento'},
    {key: 'fechaPago', value: 'Fecha Pago'},
    {key: 'monto', value: 'Monto'},
  ]

  public headerPagosSubvenciones: any[] = [
    {key: 'formulario', value: 'Formulario'},
    {key: 'folio', value: 'Folio'},
    {key: 'fechaVencimiento', value: 'Fecha Vencimiento'},
    {key: 'fechaPago', value: 'Fecha Pago'},
    {key: 'monto', value: 'Monto'},
  ]

  public headerCobranzasTotales: any[] = [
    {key: 'montoAdministrativa', value: 'Monto'},
    {key: 'cantidadAdministrativa', value: 'Cantidad'},
    {key: 'montoJudicial', value: 'Monto'},
    {key: 'cantidadJudicial', value: 'Cantidad'},
    {key: 'montoQuiebra', value: 'Monto'},
    {key: 'cantidadQuiebra', value: 'Cantidad'},
  ]

  public headerCobranzasTotalesGroups: any = [];

  public headerCuentasCobranzasAdministrativa: any[] = [
    {key: 'expediente', value: 'Expediente'},
    {key: 'año', value: 'Año'},
    {key: 'comuna', value: 'Comuna'},
    {key: 'etapa', value: 'Etapa'},
    {key: 'montoLiquidado', value: 'Monto Liquidado'},
  ]

  public headerCuentasCobranzasJudiciales: any[] = [
    {key: 'expediente', value: 'Expediente'},
    {key: 'año', value: 'Año'},
    {key: 'comuna', value: 'Comuna'},
    {key: 'etapa', value: 'Etapa'},
    {key: 'montoLiquidado', value: 'Monto Liquidado'},
    // {key: 'fechaUltimoPago', value: 'Fecha Último Pago'},
  ]

  public headerCuentasCobranzasQuiebra: any[] = [
    {key: 'expediente', value: 'Expediente'},
    {key: 'año', value: 'Año'},
    {key: 'comuna', value: 'Comuna'},
    {key: 'etapa', value: 'Etapa'},
    {key: 'montoLiquidado', value: 'Monto Liquidado'},
  ]

  public headerConveniosTotales: any[] = [
    {key: 'montoVigentes', value: 'Monto'},
    {key: 'cantidadVigentes', value: 'Cantidad'},
    {key: 'montoCaducados', value: 'Monto'},
    {key: 'cantidadCaducados', value: 'Cantidad'},
    {key: 'montoPagados', value: 'Monto'},
    {key: 'cantidadPagados', value: 'Cantidad'},
  ]

  headerConveniosTotalesGroups = [
    { label: 'Vigentes', colspan: 2 },
    { label: 'Caducados', colspan: 2 },
    { label: 'Pagados', colspan: 2 },
  ]

  public headerConveniosVigentes: any[] = [
    {key: 'resolucion', value: 'Resolucion'},
    {key: 'formulario', value: 'Formulario'},
    {key: 'folio', value: 'Folio'},
    {key: 'fechaVencimiento', value: 'Fecha Vencimiento'},
    {key: 'montoLiquidado', value: 'Monto Liquidado'},
  ]

  public headerConveniosCaducados: any[] = [
    {key: 'resolucion', value: 'Resolucion'},
    {key: 'formulario', value: 'Formulario'},
    {key: 'folio', value: 'Folio'},
    {key: 'fechaVencimiento', value: 'Fecha Vencimiento'},
    {key: 'montoLiquidado', value: 'Monto Liquidado'},
  ]

  public headerConveniosPagados: any[] = [
    {key: 'resolucion', value: 'Resolucion'},
    {key: 'formulario', value: 'Formulario'},
    {key: 'folio', value: 'Folio'},
    {key: 'fechaVencimiento', value: 'Fecha Vencimiento'},
    {key: 'montoLiquidado', value: 'Monto Liquidado'},
  ]

  public headerRegistroMercadoPublicoDeudas: any[] = [
    {key: 'formulario', value: 'Formulario'},
    {key: 'detalle', value: 'Detalle'},
  ]

  public headerDetalleCobranza: any[] = [
    {key: 'formulario', value: 'Formulario'},
    {key: 'folio', value: 'Folio'},
    {key: 'fechaVencimiento', value: 'Fecha Vencimiento'},
    {key: 'montoLiquidado', value: 'Monto Liquidado'},
  ]

  public headerDetalleCobranzaJudicial: any[] = [
    {key: 'formulario', value: 'Formulario'},
    {key: 'folio', value: 'Folio'},
    {key: 'fechaVencimiento', value: 'Fecha Vencimiento'},
    {key: 'montoLiquidado', value: 'Monto Liquidado'},
    {key: 'nConvenio', value: 'Número de convenio'},
    {key: 'fechaUltimoPago', value: 'Fecha Último Pago'},
  ]

  public headerDatosConvenio: any[] = [
    {key: 'tipoDeuda', value: 'Tipo de Deuda'},
    {key: 'cuotasOtorgadas', value: 'Cuotas Otorgadas'},
    {key: 'cuotasPagadas', value: 'Cuotas Pagadas'},
    {key: 'cuotasPorVencer', value: 'Cuotas Por Vencer'},
    {key: 'cuotasVencidas', value: 'Cuotas Vencidas'},
    {key: 'etapaActual', value: 'Etapa Actual'},
    {key: 'fechaActivacion', value: 'Fecha de Activación'},
    {key: 'fechaResolucion', value: 'Fecha de Resolución'},
    {key: 'monotCuotaFija', value: 'Monto Cuota Fija'},
    {key: 'montoCuotaContado', value: 'Monto Cuota al Contado'},
    {key: 'montoInicial', value: 'Monto Inicial'},
    {key: 'rutContribuyente', value: 'Rut Contribuyente'},
    {key: 'nombreContribuyente', value: 'Nombre Contribuyente'},
    // {key: 'resolucion', value: ''},
    {key: 'tipoConvenio', value: 'Tipo Convenio'},
    {key: 'tipoPago', value: 'Tipo Pago'},
  ]

  public headerDeudasConvenio: any[] = [
    {key: 'numero', value: 'No.'},
    {key: 'rutRol', value: 'Rut/Rol'},
    {key: 'formulario', value: 'Form.'},
    {key: 'folio', value: 'Folio'},
    {key: 'fechaVencimiento', value: 'F. Venc.'},
    {key: 'condMultas', value: 'Cond. otorgada Multas (%)'},
    {key: 'condInteres', value: 'Cond. otorgada Intereses (%)'},
    {key: 'saldo', value: 'Saldo(CLP)'},
  ]

  public headerCuotasConvenio: any[] = [ 
    {key: 'numero', value: 'Numero'},
    {key: 'monto', value: 'Monto'},
    {key: 'fechaVencimiento', value: 'Fecha Vencimiento'},
    {key: 'estadoPago', value: 'Estado Pago'},

  ]

  public contribuciones: any = null;
  public fiscalesTotal: any = null;
  public fiscales: any[] = [];
  public pagosTotal: any = null;
  public pagosVoluntarios: any[] = [];
  public pagosNoVoluntarios: any[] = [];
  public pagosRecTotal: any = null;
  public pagosRecRenta: any[] = [];
  public pagosRecDevoluciones: any[] = [];
  public pagosRecBonificaciones: any[] = [];
  public pagosRecSubvenciones: any[] = [];
  public cobranzasTotales: any = null;
  public cuentasCobranzasAdministrativa: any[] = [];
  public cuentasCobranzasJudiciales: any[] = [];
  public cuentasCobranzasQuiebra: any[] = [];
  public conveniosTotales: any = null;
  public conveniosVigentes: any[] = [];
  public conveniosCaducados: any[] = [];
  public conveniosPagados: any[] = [];
  public registroMercadoPublicoDeudas: any[] = [];
  public errores: {title: string, message: string}[] = [];

  public contribucionesDisplayedColumns: string[] = [];
  public fiscalesTotalDisplayedColumns: string[] = [];
  public fiscalesDisplayedColumns: string[] = [];
  public pagosTotalDisplayedColumns: string[] = [];
  public pagosVoluntariosDisplayedColumns: string[] = [];
  public pagosNoVoluntariosDisplayedColumns: string[] = [];
  public pagosRecTotalDisplayedColumns: string[] = [];
  public pagosRecRentaDisplayedColumns: string[] = [];
  public pagosRecDevolucionesDisplayedColumns: string[] = [];
  public pagosRecBonificacionesDisplayedColumns: string[] = [];
  public pagosRecSubvencionesDisplayedColumns: string[] = [];
  public cobranzasTotalesDisplayedColumns: string[] = [];
  public cuentasCobranzasAdministrativaDisplayedColumns: string[] = [];
  public cuentasCobranzasJudicialesDisplayedColumns: string[] = [];
  public cuentasCobranzasQuiebraDisplayedColumns: string[] = [];
  public conveniosTotalesDisplayedColumns: string[] = [];
  public conveniosVigentesDisplayedColumns: string[] = [];
  public conveniosCaducadosDisplayedColumns: string[] = [];
  public conveniosPagadosDisplayedColumns: string[] = [];
  public registroMercadoPublicoDeudasDisplayedColumns: string[] = [];
  public detalleCobranzaDisplayedColumns: string[] = [];
  public detalleCobranzaJudicialDisplayedColumns: string[] = [];
  public datosConvenioDisplayedColumns: string[] = [];
  public deudasConvenioDisplayedColumns: string[] = [];
  public cuotasConvenioDisplayedColumns: string[] = [];

  public noShowResumido: string[] = [
    'contribuciones',
    'pagosTotal',
    'pagosVoluntarios',
    'pagosNoVoluntarios',
    'pagosRecTotal',
    'pagosRecRenta',
    'pagosRecDevoluciones',
    'pagosRecBonificaciones',
    'pagosRecSubvenciones',
    'registroMercadoPublicoDeudas'
  ];

  public objReportes: any[] = [];

  public objectKeys = Object.keys;
  public expandedElements: { [key: string]: any[] } = {};

  constructor(public alertService: AlertService,) { }

  ngOnInit(): void {
    this.mapeosTablas();
    this.validateReport(this.reporteFullContent);
    this.errores = this.getErrores(this.reporteFullContent);
    this.generateDisplayedColumns();
    this.generateObjReportes();
    this.setToday();
  }

  getTipoCartola(): string {
    if(this.reporteFullContent?.TesoreriaReporte?.Reporte?.tieneCartola === true) {
      return 'con cartola';
    } 
    
    if(this.reporteFullContent?.TesoreriaReporte?.Reporte?.tieneCartola === false) {
      return 'sin cartola';
    }

    return '';
  }

  getErrores(report: any): any[] {
    const response: {title: string, message: string}[] = [];
    if(report?.TesoreriaReporte?.Reporte?.deudas?.fiscales?.detalle?.error === true) {
      response.push({
        title: 'Deudas Fiscales',
        message: report?.TesoreriaReporte?.Reporte?.deudas?.fiscales?.detalle?.message || 'Error al obtener deudas fiscales'
      });
    }
    return response;
  }

  validateReport(report: any) {
    if(!report || !report?.TesoreriaReporte || !report?.TesoreriaReporte?.Reporte) {
      this.alertService.error("Error en Al Obtener Reporte");
    }
    if(!report?.TesoreriaReporte?.Reporte?.deudas || !report?.TesoreriaReporte?.Reporte?.deudas?.fiscales) {
      this.alertService.error("Error en Al Obtener Deudas");
    }
    if(!report?.TesoreriaReporte?.Reporte?.deudas?.fiscales?.detalle) {

    } else if(report?.TesoreriaReporte?.Reporte?.deudas?.fiscales?.detalle?.error) {
      this.alertService.error(report?.TesoreriaReporte?.Reporte?.deudas?.fiscales?.detalle?.message || "Error al obtener deudas fiscales");
    }
  }

  expandAllView() {
    this.objReportes.forEach(reporte => {
      if (reporte.expandable && Array.isArray(reporte.data)) {
        this.expandedElements[reporte.key] = [...reporte.data];
        // Si es un reporte de convenios, activa las cuotas
        if (reporte.key.startsWith('convenios')) {
          reporte.data.forEach((item: any) => {
            if (item?.datos && (item.datos?.seeCuotas == false || item.datos?.seeCuotas == true)) {
              item.datos.seeCuotas = true;
            }
          });
        }
      }
    });
  }

  validaCobranzasJudiciales(): boolean {
    if((this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.judicial?.cuentas &&
      this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.judicial?.cuentas?.length > 0)
      || (this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.judicial?.monto && 
        this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.judicial?.monto > 0)
      || (this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.judicial?.cantidad && 
        this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.judicial?.cantidad > 0)) { 
          return true;
        }
    return false;
  }

  validaCobranzasAdministrativas(): boolean {
    if((this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.administrativa?.cuentas &&
      this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.administrativa?.cuentas?.length > 0)
      || (this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.administrativa?.monto && 
        this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.administrativa?.monto > 0)
      || (this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.administrativa?.cantidad && 
        this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.administrativa?.cantidad > 0)) { 
          return true;
        }
    return false;
  }

  validaCobranzasQuiebra(): boolean {
    if((this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.quiebra?.cuentas &&
      this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.quiebra?.cuentas?.length > 0)
      || (this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.quiebra?.monto && 
        this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.quiebra?.monto > 0)
      || (this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.quiebra?.cantidad && 
        this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.quiebra?.cantidad > 0)) { 
          return true;
        }
    return false;
  }

  validarCobranzasTotales(key: string): boolean {
    if(!key) return false;
    if ((key == 'montoJudicial' || key == 'cantidadJudicial') && this.validaCobranzasJudiciales()) { 
      return true;
    } else if((key == 'montoAdministrativa' || key == 'cantidadAdministrativa') && this.validaCobranzasAdministrativas()) {
      return true;
    } else if((key == 'montoQuiebra' || key == 'cantidadQuiebra') && this.validaCobranzasQuiebra()) {
      return true;
    } else {
      return false;
    }
  }

  mapeosTablas(): void {
    if(this.reporteFullContent !== null){

      // Deudas
      this.contribuciones = this.reporteFullContent?.TesoreriaReporte?.Reporte?.deudas?.contribuciones || null;

      this.fiscalesTotal = {
        cantidad: this.reporteFullContent?.TesoreriaReporte?.Reporte?.deudas?.fiscales?.cantidad,
        vencidas: this.reporteFullContent?.TesoreriaReporte?.Reporte?.deudas?.fiscales?.detalle?.totalDeudaLiquidadaMorosa,
        noVencidas: this.reporteFullContent?.TesoreriaReporte?.Reporte?.deudas?.fiscales?.detalle?.totalDeudaNoVencidaLiquidada,
        noLiquidables: this.reporteFullContent?.TesoreriaReporte?.Reporte?.deudas?.fiscales?.detalle?.acogidosArt196y197,
        montoLiquidado: null,
      }

      if((this.fiscalesTotal.vencidas || this.fiscalesTotal.vencidas == 0) ||
        (this.fiscalesTotal.noVencidas || this.fiscalesTotal.noVencidas == 0) ||
        (this.fiscalesTotal.noLiquidables || this.fiscalesTotal.noLiquidables == 0) ) {
          this.fiscalesTotal.montoLiquidado = Number(this.fiscalesTotal.vencidas || 0) + Number(this.fiscalesTotal.noVencidas || 0) + Number(this.fiscalesTotal.noLiquidables || 0);
        }

      this.fiscales = this.reporteFullContent?.TesoreriaReporte?.Reporte?.deudas?.fiscales?.detalle?.deudas || [];

      // Pagos
      this.pagosTotal = {
        montoVoluntario: this.reporteFullContent?.TesoreriaReporte?.Reporte?.pagos?.realizados?.voluntarios?.monto,
        cantidadVoluntario: this.reporteFullContent?.TesoreriaReporte?.Reporte?.pagos?.realizados?.voluntarios?.cantidad,
        montoNoVoluntario: this.reporteFullContent?.TesoreriaReporte?.Reporte?.pagos?.realizados?.noVoluntarios?.monto,
        cantidadNoVoluntario: this.reporteFullContent?.TesoreriaReporte?.Reporte?.pagos?.realizados?.noVoluntarios?.cantidad,
      }

      this.pagosVoluntarios = this.reporteFullContent?.TesoreriaReporte?.Reporte?.pagos?.realizados?.voluntarios?.detalle || [];
      this.pagosNoVoluntarios = this.reporteFullContent?.TesoreriaReporte?.Reporte?.pagos?.realizados?.noVoluntarios?.detalle || [];

      this.pagosRecTotal = {
        montoRenta: this.reporteFullContent?.TesoreriaReporte?.Reporte?.pagos?.recibidos?.renta?.monto,
        cantidadRenta: this.reporteFullContent?.TesoreriaReporte?.Reporte?.pagos?.recibidos?.renta?.cantidad,
        montoDevoluciones: this.reporteFullContent?.TesoreriaReporte?.Reporte?.pagos?.recibidos?.devoluciones?.monto,
        cantidadDevoluciones: this.reporteFullContent?.TesoreriaReporte?.Reporte?.pagos?.recibidos?.devoluciones?.cantidad,
        montoBonificaciones: this.reporteFullContent?.TesoreriaReporte?.Reporte?.pagos?.recibidos?.bonificaciones?.monto,
        cantidadBonificaciones: this.reporteFullContent?.TesoreriaReporte?.Reporte?.pagos?.recibidos?.bonificaciones?.cantidad,
        montoSubvenciones: this.reporteFullContent?.TesoreriaReporte?.Reporte?.pagos?.recibidos?.subvenciones?.monto,
        cantidadSubvenciones: this.reporteFullContent?.TesoreriaReporte?.Reporte?.pagos?.recibidos?.subvenciones?.cantidad,
      }

      this.pagosRecRenta = this.reporteFullContent?.TesoreriaReporte?.Reporte?.pagos?.recibidos?.renta?.detalle || [];
      this.pagosRecDevoluciones = this.reporteFullContent?.TesoreriaReporte?.Reporte?.pagos?.recibidos?.devoluciones?.detalle || [];
      this.pagosRecBonificaciones = this.reporteFullContent?.TesoreriaReporte?.Reporte?.pagos?.recibidos?.bonificaciones?.detalle || [];
      this.pagosRecSubvenciones = this.reporteFullContent?.TesoreriaReporte?.Reporte?.pagos?.recibidos?.subvenciones?.detalle || [];

      // Cobranzas
      this.cobranzasTotales = {};

      if(this.validaCobranzasAdministrativas()) {
        this.cobranzasTotales.montoAdministrativa = this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.administrativa?.monto;
        this.cobranzasTotales.cantidadAdministrativa = this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.administrativa?.cantidad;
      }

      if(this.validaCobranzasJudiciales())  {
        this.cobranzasTotales.montoJudicial = this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.judicial?.monto;
        this.cobranzasTotales.cantidadJudicial = this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.judicial?.cantidad;
      }

      if(this.validaCobranzasQuiebra()) {
        this.cobranzasTotales.montoQuiebra = this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.quiebra?.monto;
        this.cobranzasTotales.cantidadQuiebra = this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.quiebra?.cantidad;
      }

      this.cuentasCobranzasAdministrativa = this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.administrativa?.cuentas || [];
      this.cuentasCobranzasAdministrativa.forEach((e) => {
        if(e && Object.keys(e).length > 0 && e?.detalle && e?.detalle?.length > 0) {
          this.addDetailExtraData(e.detalle);
          e.isExpanded = false;
        }
      });
      this.cuentasCobranzasJudiciales = this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.judicial?.cuentas || [];
      this.cuentasCobranzasJudiciales.forEach((e) => {
        if(e && Object.keys(e).length > 0 && e?.detalle && e?.detalle?.length > 0) {
          // Debo agregar al detalle el numero de convenio y fecha ultimo pago
          this.addDetailExtraData(e.detalle);
          //console.log("with extra data:", e.detalle);
          e.isExpanded = false;
        }
      });
      this.cuentasCobranzasQuiebra = this.reporteFullContent?.TesoreriaReporte?.Reporte?.cobranzas?.quiebra?.cuentas || [];
      this.cuentasCobranzasQuiebra.forEach((e) => {
        if(e && Object.keys(e).length > 0 && e?.detalle && e?.detalle?.length > 0) {
          this.addDetailExtraData(e.detalle);
          e.isExpanded = false;
        }
      });

      // Convenios
      this.conveniosTotales = {
        montoVigentes: this.reporteFullContent?.TesoreriaReporte?.Reporte?.convenios?.vigentes?.monto,
        cantidadVigentes: this.reporteFullContent?.TesoreriaReporte?.Reporte?.convenios?.vigentes?.cantidad,
        montoCaducados: this.reporteFullContent?.TesoreriaReporte?.Reporte?.convenios?.caducados?.monto,
        cantidadCaducados: this.reporteFullContent?.TesoreriaReporte?.Reporte?.convenios?.caducados?.cantidad,
        montoPagados: this.reporteFullContent?.TesoreriaReporte?.Reporte?.convenios?.pagados?.monto,
        cantidadPagados: this.reporteFullContent?.TesoreriaReporte?.Reporte?.convenios?.pagados?.cantidad,
      }

      this.conveniosVigentes = this.reporteFullContent?.TesoreriaReporte?.Reporte?.convenios?.vigentes?.detalle || [];
      this.conveniosCaducados = this.reporteFullContent?.TesoreriaReporte?.Reporte?.convenios?.caducados?.detalle || [];
      this.conveniosPagados = this.reporteFullContent?.TesoreriaReporte?.Reporte?.convenios?.pagados?.detalle || [];
      
      this.addDatosToConvenio(this.conveniosVigentes);
      this.addDatosToConvenio(this.conveniosCaducados);
      this.addDatosToConvenio(this.conveniosPagados);

      // Registro Mercado Publico
      this.registroMercadoPublicoDeudas = this.reporteFullContent?.TesoreriaReporte?.Reporte?.registroMercadoPublico?.deudas || [];

    }
  }

  log(item: any) {
    console.log(item)
  }

  // Agrega el numero de convenio y fecha de ultimo pago
  addDetailExtraData(detalle: any) {
    detalle.forEach((element: any) => {
      if(element && Object.keys(element).length > 0) {
        const folio = element?.folio || ''
        // Busco el numero de convenio en la lista de convenios con el folio
        const nConvenio = this.searchConvenioByFolio(folio);
        element.nConvenio = nConvenio;
  
        // Busco la fecha de ultimo pago con este folio
        const fechaUltimoPago = this.searchFechaUltimoPago(folio);
        element.fechaUltimoPago = fechaUltimoPago
      }
    });
  }

  // Busca el convenio por numero de folio, en los convenios vigentes, caducados y pagados
  searchConvenioByFolio(folio: any) {
    if(!folio) return '';

    const convenioVigente = this.getConveniosVigentesDetalle().find(element => element?.folio === folio);
    if(convenioVigente) return convenioVigente?.resolucion || ''

    const convenioCaducado = this.getConveniosCaducadosDetalle().find(element => element?.folio === folio);
    if(convenioCaducado) return convenioCaducado?.resolucion || ''

    const convenioPagado = this.getConveniosPagadosDetalle().find(element => element?.folio === folio);
    if(convenioPagado) return convenioPagado?.resolucion || ''

    return '';
  }

  searchFechaUltimoPago(folio: string) {
    if(!folio) return '';

    const pagosVoluntarios = this.getPagosVoluntarios();
    const pagosNoVoluntarios = this.getPagosNoVoluntarios();

    const pagosTotales = pagosVoluntarios.concat(pagosNoVoluntarios)
    const pagosTotalesFolio = pagosTotales.filter(element => element?.folio === folio);
    //console.log("pagosTotalesFolio:", pagosTotalesFolio)

    if(pagosTotalesFolio && pagosTotalesFolio.length === 0) return '';

    const latestFechaPagoObject = pagosTotalesFolio.reduce((latest, current) => {
      return new Date(current?.fechaPago) > new Date(latest?.fechaPago) ? current : latest;
    }, pagosTotalesFolio[0]);

    return latestFechaPagoObject?.fechaPago || '';
  }

  addDatosToConvenio(convenios: any[]) {
    convenios.forEach((convenio) => {
      this.searchDatosConvenioByResolucion(convenio)
    })
  }

  // Buscar convenio por resolucion
  searchDatosConvenioByResolucion(itemConvenio: any) {
    //const resolucion = itemConvenio.resolucion.toString();
    if (!itemConvenio?.resolucion) return;
    const resolucion = itemConvenio.resolucion.toString();

    const convenioVigenteDatos = this.getConveniosVigentesDatos().find(element => element?.resolucion === resolucion);
    if(convenioVigenteDatos){
      itemConvenio.datos = JSON.parse(JSON.stringify(convenioVigenteDatos?.detalle?.informacion || {}));
      itemConvenio.datos.cuotas = convenioVigenteDatos?.cuotas || [];
      itemConvenio.datos.deudas = convenioVigenteDatos?.detalle?.deudas || [];
      itemConvenio.datos.tipoDeuda = convenioVigenteDatos?.detalle?.tipoDeuda || '';
      itemConvenio.datos.tipoPago = convenioVigenteDatos?.tipoPago || '';
      itemConvenio.datos.seeCuotas = false;
      //console.log(itemConvenio)
      return
    } 

    const convenioCaducado = this.getConveniosCaducadosDatos().find(element => element?.resolucion === resolucion);
    if(convenioCaducado){
      itemConvenio.datos = JSON.parse(JSON.stringify(convenioCaducado?.detalle?.informacion || {})); //convenioCaducado.detalle.informacion;
      itemConvenio.datos.cuotas = convenioCaducado?.cuotas || [];
      itemConvenio.datos.deudas = convenioCaducado?.detalle?.deudas || [];
      itemConvenio.datos.tipoDeuda = convenioCaducado?.detalle?.tipoDeuda || '';
      itemConvenio.datos.tipoPago = convenioCaducado?.tipoPago || '';
      itemConvenio.datos.seeCuotas = false;
      return
    }

    const convenioPagado = this.getConveniosPagadosDatos().find(element => element?.resolucion === resolucion);
    if(convenioPagado) {
      itemConvenio.datos = JSON.parse(JSON.stringify(convenioPagado?.detalle?.informacion || {})); //convenioPagado.detalle.informacion
      itemConvenio.datos.cuotas = convenioPagado?.cuotas || [];
      itemConvenio.datos.deudas = convenioPagado?.detalle?.deudas || [];
      itemConvenio.datos.tipoDeuda = convenioPagado?.detalle?.tipoDeuda || '';
      itemConvenio.datos.tipoPago = convenioPagado?.tipoPago || '';
      itemConvenio.datos.seeCuotas = false;
      return
    }
  }

  getConveniosVigentesDatos(): any[] {
    return this.reporteFullContent?.TesoreriaReporte?.Reporte?.convenios?.vigentes?.datos || []
  }

  getConveniosCaducadosDatos(): any[] {
    return this.reporteFullContent?.TesoreriaReporte?.Reporte?.convenios?.caducados?.datos || [];
  }

  getConveniosPagadosDatos(): any[] {
    return this.reporteFullContent?.TesoreriaReporte?.Reporte?.convenios?.pagados?.datos || [];
  }

  getConveniosVigentesDetalle(): any[] {
    return this.reporteFullContent?.TesoreriaReporte?.Reporte?.convenios?.vigentes?.detalle || []
  }

  getConveniosCaducadosDetalle(): any[] {
    return this.reporteFullContent?.TesoreriaReporte?.Reporte?.convenios?.caducados?.detalle || [];
  }

  getConveniosPagadosDetalle(): any[] {
    return this.reporteFullContent?.TesoreriaReporte?.Reporte?.convenios?.pagados?.detalle || [];
  }

  getPagosVoluntarios(): any[] {
    return this.reporteFullContent?.TesoreriaReporte?.Reporte?.pagos?.realizados?.voluntarios?.detalle || [];
  }

  getPagosNoVoluntarios(): any[] {
    return this.reporteFullContent?.TesoreriaReporte?.Reporte?.pagos?.realizados?.noVoluntarios?.detalle || [];
  }

  expandAllConvenios(convenios: any[]) {
    convenios.forEach(convenio => {
      convenio.isExpanded = true;
      if(convenio.datos) {
        convenio.datos.seeCuotas = true;
      }
    });
  }

  generateDisplayedColumns(): void {
    this.contribucionesDisplayedColumns = this.headerContribuciones.map(header => header.key);
    this.fiscalesTotalDisplayedColumns = this.headerFiscalesTotales.map(header => header.key);
    this.fiscalesDisplayedColumns = this.headerFiscales.map(header => header.key);
    this.pagosTotalDisplayedColumns = this.headerPagosTotales.map(header => header.key);
    this.pagosVoluntariosDisplayedColumns = this.headerPagosVoluntarios.map(header => header.key);
    this.pagosNoVoluntariosDisplayedColumns = this.headerPagosNoVoluntarios.map(header => header.key);
    this.pagosRecTotalDisplayedColumns = this.headerPagosRecTotales.map(header => header.key);
    this.pagosRecRentaDisplayedColumns = this.headerPagosRenta.map(header => header.key);
    this.pagosRecDevolucionesDisplayedColumns = this.headerPagosDevoluciones.map(header => header.key);
    this.pagosRecBonificacionesDisplayedColumns = this.headerPagosBonificaciones.map(header =>  header.key);
    this.pagosRecSubvencionesDisplayedColumns = this.headerPagosSubvenciones.map(header => header.key);
    this.cuentasCobranzasAdministrativaDisplayedColumns = this.headerCuentasCobranzasAdministrativa.map(header => header.key);
    this.cuentasCobranzasJudicialesDisplayedColumns = this.headerCuentasCobranzasJudiciales.map(header => header.key);
    this.cuentasCobranzasQuiebraDisplayedColumns = this.headerCuentasCobranzasQuiebra.map(header => header.key);
    this.conveniosTotalesDisplayedColumns = this.headerConveniosTotales.map(header => header.key);
    this.conveniosVigentesDisplayedColumns = this.headerConveniosVigentes.map(header => header.key);
    this.conveniosCaducadosDisplayedColumns = this.headerConveniosCaducados.map(header => header.key);
    this.conveniosPagadosDisplayedColumns = this.headerConveniosPagados.map(header => header.key);
    this.registroMercadoPublicoDeudasDisplayedColumns = this.headerRegistroMercadoPublicoDeudas.map(header => header.key);
    this.detalleCobranzaDisplayedColumns = this.headerDetalleCobranza.map(header => header.key);
    this.detalleCobranzaJudicialDisplayedColumns = this.headerDetalleCobranzaJudicial.map(header => header.key);

    this.datosConvenioDisplayedColumns = this.headerDatosConvenio.map(header => header.key);
    this.deudasConvenioDisplayedColumns = this.headerDeudasConvenio.map(header => header.key);
    this.cuotasConvenioDisplayedColumns = this.headerCuotasConvenio.map(header => header.key);
  }

  generateObjReportes(): void {
    this.headerCobranzasTotales = [];
    this.headerCobranzasTotalesGroups = [];

    if(this.validaCobranzasAdministrativas()) {
      this.headerCobranzasTotalesGroups.push({
        label: 'Administrativa', colspan: 2
      });
      this.headerCobranzasTotales.push({key: 'montoAdministrativa', value: 'Monto'});
      this.headerCobranzasTotales.push({key: 'cantidadAdministrativa', value: 'Cantidad'});
    }
    if(this.validaCobranzasJudiciales()) {
      this.headerCobranzasTotalesGroups.push({
        label: 'Judicial', colspan: 2
      });
      this.headerCobranzasTotales.push({key: 'montoJudicial', value: 'Monto'});
      this.headerCobranzasTotales.push({key: 'cantidadJudicial', value: 'Cantidad'});
    }
    if(this.validaCobranzasQuiebra()) {
      this.headerCobranzasTotalesGroups.push({
        label: 'Quiebra', colspan: 2
      });
      this.headerCobranzasTotales.push({key: 'montoQuiebra', value: 'Monto'});
      this.headerCobranzasTotales.push({key: 'cantidadQuiebra', value: 'Cantidad'});
    }

    if (this.headerCobranzasTotales.length === 0) { // Si no hay datos se llena el header para mostrar sin informacion como fila unica
      this.headerCobranzasTotalesGroups = [
        { label: 'Administrativa', colspan: 2 },
        { label: 'Judicial', colspan: 2 },
        { label: 'Quiebra', colspan: 2 }
      ];
      this.headerCobranzasTotales = [
        {key: 'montoAdministrativa', value: 'Monto'},
        {key: 'cantidadAdministrativa', value: 'Cantidad'},
        {key: 'montoJudicial', value: 'Monto'},
        {key: 'cantidadJudicial', value: 'Cantidad'},
        {key: 'montoQuiebra', value: 'Monto'},
        {key: 'cantidadQuiebra', value: 'Cantidad'}
      ];
    }

    this.cobranzasTotalesDisplayedColumns = [];
    this.cobranzasTotalesDisplayedColumns = this.headerCobranzasTotales.map(header => header.key);

    this.objReportes = [
      {
        key: 'contribuciones', 
        title: 'Deudas Contribuciones', 
        data: this.contribuciones, 
        headers: this.headerContribuciones, 
        displayedColumns: this.contribucionesDisplayedColumns
      },
      {
        key: 'fiscalesTotal', 
        title: 'Deudas Fiscales Totales', 
        data: this.fiscalesTotal, 
        headers: this.headerFiscalesTotales, 
        displayedColumns: this.fiscalesTotalDisplayedColumns
      },
      {
        key: 'fiscales', 
        title: 'Deudas Fiscales Detalle', 
        data: this.fiscales, 
        headers: this.headerFiscales, 
        displayedColumns: this.fiscalesDisplayedColumns
      },
      {
        key: 'cobranzasTotales', 
        title: 'Total Cobranzas', 
        data: this.cobranzasTotales, 
        headers: this.headerCobranzasTotales, 
        displayedColumns: this.cobranzasTotalesDisplayedColumns, 
        headerGroups: this.headerCobranzasTotalesGroups
      },
      {
        key: 'cuentasCobranzasAdministrativa', 
        title: 'Cuentas Cobranzas Administrativas', 
        data: this.cuentasCobranzasAdministrativa, 
        headers: this.headerCuentasCobranzasAdministrativa, 
        displayedColumns: this.cuentasCobranzasAdministrativaDisplayedColumns, 
        expandable: 'simple',
        expandableData: {
          header: this.headerDetalleCobranza,
          displayedColumns: this.detalleCobranzaDisplayedColumns,
        }
      },
      {
        key: 'cuentasCobranzasJudiciales', 
        title: 'Cuentas Cobranzas Judiciales', 
        data: this.cuentasCobranzasJudiciales, 
        headers: this.headerCuentasCobranzasJudiciales, 
        displayedColumns: this.cuentasCobranzasJudicialesDisplayedColumns,
        expandable: 'simple',
        expandableData: {
          header: this.headerDetalleCobranzaJudicial,
          displayedColumns: this.detalleCobranzaJudicialDisplayedColumns,
        }
      },
      {
        key: 'cuentasCobranzasQuiebra', 
        title: 'Cuentas Cobranzas Quiebra', 
        data: this.cuentasCobranzasQuiebra, 
        headers: this.headerCuentasCobranzasQuiebra, 
        displayedColumns: this.cuentasCobranzasQuiebraDisplayedColumns,
        expandable: 'simple',
        expandableData: {
          header: this.headerCuentasCobranzasQuiebra,
          displayedColumns: this.cuentasCobranzasQuiebraDisplayedColumns,
        }
      },
      {
        key: 'conveniosTotales', 
        title: 'Total Convenios', 
        data: this.conveniosTotales, 
        headers: this.headerConveniosTotales, 
        displayedColumns: this.conveniosTotalesDisplayedColumns, 
        headerGroups: this.headerConveniosTotalesGroups
      },
      {
        key: 'conveniosVigentes', 
        title: 'Convenios Vigentes', 
        data: this.conveniosVigentes, 
        headers: this.headerConveniosVigentes, 
        displayedColumns: this.conveniosVigentesDisplayedColumns,
        expandable: 'convenio',
        expandableData: {
          headerDatos: this.headerDatosConvenio,
          displayedColumnsDatos: this.datosConvenioDisplayedColumns,
          headerDeudas: this.headerDeudasConvenio,
          displayedColumnsDeudas: this.deudasConvenioDisplayedColumns,
          headerCuotas: this.headerCuotasConvenio,
          displayedColumnsCuotas: this.cuotasConvenioDisplayedColumns,
        }

      },
      {
        key: 'conveniosCaducados', 
        title: 'Convenios Caducados', 
        data: this.conveniosCaducados, 
        headers: this.headerConveniosCaducados, 
        displayedColumns: this.conveniosCaducadosDisplayedColumns,
        expandable: 'convenio',
        expandableData: {
          headerDatos: this.headerDatosConvenio,
          displayedColumnsDatos: this.datosConvenioDisplayedColumns,
          headerDeudas: this.headerDeudasConvenio,
          displayedColumnsDeudas: this.deudasConvenioDisplayedColumns,
          headerCuotas: this.headerCuotasConvenio,
          displayedColumnsCuotas: this.cuotasConvenioDisplayedColumns,
        }
      },
      {
        key: 'conveniosPagados', 
        title: 'Convenios Pagados', 
        data: this.conveniosPagados, 
        headers: this.headerConveniosPagados, 
        displayedColumns: this.conveniosPagadosDisplayedColumns,
        expandable: 'convenio',
        expandableData: {
          headerDatos: this.headerDatosConvenio,
          displayedColumnsDatos: this.datosConvenioDisplayedColumns,
          headerDeudas: this.headerDeudasConvenio,
          displayedColumnsDeudas: this.deudasConvenioDisplayedColumns,
          headerCuotas: this.headerCuotasConvenio,
          displayedColumnsCuotas: this.cuotasConvenioDisplayedColumns,
        }
      },
      {
        key: 'pagosTotal', 
        title: 'Total Pagos Realizados', 
        data: this.pagosTotal, 
        headers: this.headerPagosTotales, 
        displayedColumns: this.pagosTotalDisplayedColumns, 
        headerGroups: this.headerPagosTotalesGroups
      },
      {
        key: 'pagosVoluntarios', 
        title: 'Detalle Pagos Voluntarios', 
        data: this.pagosVoluntarios, 
        headers: this.headerPagosVoluntarios, 
        displayedColumns: this.pagosVoluntariosDisplayedColumns
      },
      {
        key: 'pagosNoVoluntarios', 
        title: 'Detalle Pagos No Voluntarios', 
        data: this.pagosNoVoluntarios, 
        headers: this.headerPagosNoVoluntarios, 
        displayedColumns: this.pagosNoVoluntariosDisplayedColumns
      },
      {
        key: 'pagosRecTotal', 
        title: 'Total Pagos Recibidos', 
        data: this.pagosRecTotal, 
        headers: this.headerPagosRecTotales, 
        displayedColumns: this.pagosRecTotalDisplayedColumns, 
        headerGroups: this.headerPagosRecTotalesGroups
      },
      {
        key: 'pagosRecRenta', 
        title: 'Detalle Pagos Recibidos Renta', 
        data: this.pagosRecRenta, 
        headers: this.headerPagosRenta, 
        displayedColumns: this.pagosRecRentaDisplayedColumns
      },
      {
        key: 'pagosRecDevoluciones', 
        title: 'Detalle Pagos Recibidos Devoluciones', 
        data: this.pagosRecDevoluciones, 
        headers: this.headerPagosDevoluciones, 
        displayedColumns: this.pagosRecDevolucionesDisplayedColumns
      },
      {
        key: 'pagosRecBonificaciones', 
        title: 'Detalle Pagos Recibidos Bonificaciones', 
        data: this.pagosRecBonificaciones, 
        headers: this.headerPagosBonificaciones, 
        displayedColumns: this.pagosRecBonificacionesDisplayedColumns
      },
      {
        key: 'pagosRecSubvenciones', 
        title: 'Detalle Pagos Recibidos Subvenciones', 
        data: this.pagosRecSubvenciones, 
        headers: this.headerPagosBonificaciones, 
        displayedColumns: this.pagosRecSubvencionesDisplayedColumns
      },
      {
        key: 'registroMercadoPublicoDeudas', 
        title: 'Registro Mercado Publico Deudas', 
        data: this.registroMercadoPublicoDeudas, 
        headers: this.headerRegistroMercadoPublicoDeudas, 
        displayedColumns: this.registroMercadoPublicoDeudasDisplayedColumns
      }
    ];
  }

  setToday() {
    this.today = `${new Date().getFullYear()}${(new Date().getMonth() + 1 < 10?  '0'+(new Date().getMonth() + 1) : 
      new Date().getMonth() + 1)}${new Date().getDate()}`;        
  }

  validateTypeArray(data: any): boolean {
    return Array.isArray(data);
  }

  getDataSource(data: any): any[] {
    if (!data) return [];
    if (Array.isArray(data)) return data.length > 0 ? data : [];
    
    if (typeof data === 'object') {
      const values = Object.values(data);
      const hasValidData = values.some(val => val !== null && val !== undefined && val !== '');
      
      if (!hasValidData) {
        return [];
      }
      return [data];
    }
    
    return [data];
  }

  getArrayGroups(array: any[]): string[] {
    if(!array || !Array.isArray(array)) return [];
    return array.map((item, index) => index.toString());
  }

  toString(value: any): string {
    return value || value == 0 ? value.toString() : '';
  }

  toggleExpand(reporteKey: string, row: any) {
    if (!this.expandedElements[reporteKey]) {
      this.expandedElements[reporteKey] = [];
    }
    const index = this.expandedElements[reporteKey].indexOf(row);
    if (index > -1) {
      this.expandedElements[reporteKey].splice(index, 1);
    } else {
      this.expandedElements[reporteKey].push(row);
    }
  }

  isExpanded(reporteKey: string, row: any): boolean {
    return this.expandedElements[reporteKey]?.includes(row);
  }

}
